import { render, staticRenderFns } from "./AdvocatAppCardIn.vue?vue&type=template&id=9341ac24&scoped=true&lang=pug&"
import script from "./AdvocatAppCardIn.vue?vue&type=script&lang=js&"
export * from "./AdvocatAppCardIn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9341ac24",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
